import { render, staticRenderFns } from "./databaseCom.vue?vue&type=template&id=74ed415e&scoped=true"
import script from "./databaseCom.vue?vue&type=script&lang=js"
export * from "./databaseCom.vue?vue&type=script&lang=js"
import style0 from "./databaseCom.vue?vue&type=style&index=0&id=74ed415e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed415e",
  null
  
)

export default component.exports